// extracted by mini-css-extract-plugin
export default {"logoArea":"Logo_logoArea__6ACJ7","logo":"Logo_logo__dypWq","logoText":"Logo_logoText__ovCZY"};